"use client";

import { useEffect } from "react";
import {
  getMobilePlatform,
  getStoreUrlForPlatform,
  GOOGLE_PLAY_URL,
  IOS_APP_URL,
} from "@/utils/appDownload";

function getStoreUrl() {
  const platform = getMobilePlatform(
    navigator.userAgent || navigator.vendor || "",
    navigator.platform,
    navigator.maxTouchPoints,
  );

  if (platform === "desktop") return null;
  return getStoreUrlForPlatform(platform);
}

export default function DownloadRedirect() {
  useEffect(() => {
    const storeUrl = getStoreUrl();
    if (storeUrl) {
      window.location.replace(storeUrl);
    }
  }, []);

  return null;
}

export { IOS_APP_URL as APP_STORE_URL, GOOGLE_PLAY_URL };
